// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import React from 'react'
import IntlCommon from '@stores/IntlCommon'
import { FormattedMessage, useIntl, injectIntl } from 'react-intl'

export const transform = (id, val?, type?) => {
  if (IntlCommon.intlFun.formatMessage && !type) {
    return IntlCommon.intlFun.formatMessage(
      {
        id,
      },
      val
    )
  } else {
    return <FormattedMessage id={id} values={val}/>
  }
}
// 返回年月格式
export const transformDate = date => {
  if (IntlCommon.intlFun.formatDate && IntlCommon.browserLanguage !== 'th') {
    return IntlCommon.intlFun.formatDate(date, {
      year: 'numeric',
      month: 'long',
    })
  } else {
    const time = IntlCommon.intlFun
      .formatDate(date, {
        year: 'numeric',
        month: 'long',
      })
      .split(' ')
    // tslint:disable-next-line
    return `${time[0]} ${time[1] - 543}`
  }
}
// 返回月日格式
export const transformMd = date => {
  if (IntlCommon.intlFun.formatDate) {
    return IntlCommon.intlFun.formatDate(date, {
      month: 'long',
      day: 'numeric',
    })
  }
}
// 返回月日时分格式
export const transformMdHM = date => {
  if (IntlCommon.intlFun.formatDate) {
    return IntlCommon.intlFun.formatDate(date, {
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
    })
  }
}

export const getVersionTip = (lang, ver) => {
  const langMes = {
    en: `Sorry, your browser version is too low, which may affect the use of some functions of Zhiniao web version. Please upgrade to IE${ver} or above or use Chrome to open Zhiniao web version.`,
    zh: `抱歉，您的浏览器版本过低可能影响e祺学网页版部分功能的使用。请升级到IE${ver}及以上的浏览器或使用chrome浏览器打开e祺学网页版。`,
    ko: `抱歉，您的浏览器版本过低可能影响e祺学网页版部分功能的使用。请升级到IE${ver}及以上的浏览器或使用chrome浏览器打开e祺学网页版。`,
    ja: `抱歉，您的浏览器版本过低可能影响e祺学网页版部分功能的使用。请升级到IE${ver}及以上的浏览器或使用chrome浏览器打开e祺学网页版。`,
    tw: `抱歉，您的浏览器版本过低可能影响e祺学网页版部分功能的使用。请升级到IE${ver}及以上的浏览器或使用chrome浏览器打开e祺学网页版。`,
    ms: `抱歉，您的浏览器版本过低可能影响e祺学网页版部分功能的使用。请升级到IE${ver}及以上的浏览器或使用chrome浏览器打开e祺学网页版。`,
    th: `抱歉，您的浏览器版本过低可能影响e祺学网页版部分功能的使用。请升级到IE${ver}及以上的浏览器或使用chrome浏览器打开e祺学网页版。`,
  }
  return langMes[lang]
}
